// extracted by css-extract-rspack-plugin
module.exports =  {"dropdown":"DropDownMenu__dropdown--rrI_k"};